<!-- The row opens the request on click; keyboard and screen reader users get the same
     action from the summary button, kept separate from the actions menu (no nested controls) -->
<mat-list-item
    appPreventDoubleClick
    (throttledClick)="openLeaveRequestDialog.emit(leaveRequest)"
> 
    <div class="leaveRequest-row">
        <div
            class="left"
            role="button"
            tabindex="0"
            [attr.aria-label]="(leaveRequest.timeOffType?.name || 'Time off request')
                + ', ' + moment(leaveRequest.from).format('ll') + ' – ' + moment(leaveRequest.to).format('ll')
                + (leaveRequest.halfDay === true ? ', Half Day' : '')
                + ', ' + (leaveRequest.requestStatus?.name || '')"
            (keydown.enter)="$event.stopPropagation(); openLeaveRequestDialog.emit(leaveRequest)"
            (keydown.space)="$event.preventDefault(); $event.stopPropagation(); openLeaveRequestDialog.emit(leaveRequest)"
        >
            <div class="timeofftype-details">
                <img *ngIf="iconUrl" [src]="domSanitizer.bypassSecurityTrustUrl(iconUrl)" [attr.alt]="(leaveRequest.timeOffType?.name || 'Time off type') + ' icon'"/>
                <span>{{leaveRequest.timeOffType.name}}</span>
            </div>
            <div class="dates" [attr.aria-label]="'From ' + moment(leaveRequest.from).format('ll') + ' to ' + moment(leaveRequest.to).format('ll')">
                {{ moment(leaveRequest.from).format('ll') }} - {{ moment(leaveRequest.to).format('ll') }}
            </div>
            <mat-chip-set class="half-day" aria-label="Request details">
                <mat-chip class="green-chip" *ngIf="leaveRequest.halfDay === true" appLocalizationPopupDirective [localizationCode]="'LeaveRequestHalfDay'">{{ 'LeaveRequestHalfDay' | translate: {Default: "Half Day"} }}</mat-chip>
            </mat-chip-set>
        </div>
        
        <div
            class="middle"
            role="group"
            tabindex="0"
            [attr.aria-label]="'Approver' + ((leaveRequest?.managers?.length || 0) > 1 ? 's' : '') + ': ' + (showEmployeeTooltip(leaveRequest?.managers) || 'Not assigned')"
        >
            <ng-container *ngIf="(leaveRequest?.managers?.length || 0) > 1">
                <mat-icon class="material-icons-outlined employee-list-icon" [matBadge]="leaveRequest.managers.length" [matTooltip]="showEmployeeTooltip(leaveRequest.managers)" [attr.aria-label]="'Approvers: ' + leaveRequest.managers.length + '. ' + showEmployeeTooltip(leaveRequest.managers)">
                    account_circle
                </mat-icon>
            </ng-container>

            <ng-container *ngIf="(leaveRequest?.managers?.length || 0) == 1">
                <ng-container *ngFor="let employee of leaveRequest.managers">
                    <div class="employee-name">
                        <app-employee-image [profilePhoto]="employee.profilePhoto" [width]="35" [height]="35" [round]="true" *ngIf="!isLoading"></app-employee-image>

                        <span class="employee">
                            {{employee.firstName}} {{employee.lastName}}
                        </span>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        
        <div class="right">
            <mat-chip-set aria-label="Request status">
                <mat-chip 
                    [ngClass]="{
                        'red-chip': leaveRequest.requestStatus?.id === 'trs_Denied',
                        'green-chip': leaveRequest.requestStatus?.id === 'trs_Approved',
                        'orange-chip': leaveRequest.requestStatus?.id === 'trs_Pending'
                    }"
                >{{ leaveRequest.requestStatus?.name }}</mat-chip>
            </mat-chip-set>

            <ng-container *ngIf="leaveRequest.requestStatus?.id !== 'trs_Approved'">
                <button class="settings-button" mat-mini-fab [matMenuTriggerFor]="settings" appPreventDoubleClick (throttledClick)="$event.stopPropagation()" aria-label="Open request actions" type="button">
                    <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
                </button>
                <div class="settings-menu">
                    <mat-menu #settings="matMenu" xPosition="before">
                        <button class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openLeaveRequestDialog.emit(leaveRequest)" mat-menu-item type="button">
                            <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">description</mat-icon>
                            {{ 'EmployeeTimeOffTypeView' | translate: {Default: "View"} }}
                        </button>
                        <button appLocalizationPopupDirective [localizationCode]="'EmployeeTimeOffTypeEdit'" class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openEditRequestDialog(leaveRequest.id)" mat-menu-item *ngIf="leaveRequest.requestStatus?.id === 'trs_Pending'">
                            <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">edit</mat-icon>
                            {{ 'EmployeeTimeOffTypeEdit' | translate: {Default: "Edit"} }}
                        </button>
                        <button appLocalizationPopupDirective [localizationCode]="'EmployeeTimeOffTypeCancel'" class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openConfirmDeleteDialog();" mat-menu-item>
                            <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">delete</mat-icon>
                            {{ 'EmployeeTimeOffTypeCancel' | translate: {Default: "Cancel"} }}
                        </button>
                    </mat-menu>
                </div>
            </ng-container>

            <ng-container *ngIf="leaveRequest.requestStatus?.id === 'trs_Approved' && isInFuture(leaveRequest.from)">
                <button class="settings-button" mat-mini-fab [matMenuTriggerFor]="settings" appPreventDoubleClick (throttledClick)="$event.stopPropagation()" aria-label="Open request actions" type="button">
                    <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
                </button>
                <div class="settings-menu">
                    <mat-menu #settings="matMenu" xPosition="before">
                        <button class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openLeaveRequestDialog.emit(leaveRequest)" mat-menu-item type="button">
                            <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">description</mat-icon>
                            {{ 'EmployeeTimeOffTypeView' | translate: {Default: "View"} }}
                        </button>
                        <button 
                            type="button"
                            class="settings-menu__item material-icons-outlined" 
                            appPreventDoubleClick 
                            (throttledClick)="$event.stopPropagation(); openConfirmDeleteDialog();" 
                            mat-menu-item
                            appLocalizationPopupDirective 
                            [localizationCode]="'EmployeeTimeOffTypeCancel'"
                        >
                            <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">delete</mat-icon>
                            {{ 'EmployeeTimeOffTypeCancel' | translate: {Default: "Cancel"} }}
                        </button>
                    </mat-menu>
                </div>
            </ng-container>

        </div>
    </div>    
</mat-list-item>